<template>
	<div id="orthoPlanButtons" class="ortho-mode-item">
		<div id="orthoSaveButtons">
			<button id="orthoPlanCancel" class="ortho-button" v-on:click="cancelPlanMode()">
				CANCEL
			</button>
			<button id="orthoPlanSaveExit" class="ortho-button ortho-save" v-on:click="saveExitPlanMode()">
				SAVE & EXIT
			</button>
			<button id="orthoPlanSaveAsStage" class="ortho-button ortho-save" v-on:click="saveAsStagePlanMode()">
				SAVE AS...
			</button>
			<button id="orthoPlanNextStage" class="ortho-button ortho-save" v-on:click="nextStagePlanMode()">
				NEXT STAGE
			</button>
		</div>
		<button id="orthoToothDoneButton" class="ortho-button" v-on:click="exitToothMode()">
			DONE
		</button>

		<button v-show="!mode.isIntraoralView" class="ortho-button orto-report-button" v-on:click="anatomyChangeReportClick()">
			ANATOMY CHANGE REPORT
		</button>
	</div>
</template>

<script>
import {
	cancelOrthoChanges,
	loadOrthoStage,
	saveOrthoChanges,
	exitEditToothMode
} from "./OrthoPlanMode";
import { anatomyChangeReport } from "./OrtoReporting";
import { showOrthoStageDialog } from "./OrthoStageDialog.vue";

export default {
	name: "OrthoPlanButtons",
	props: ["mode", "editContext"],
	components: {},
	methods: {
		exitToothMode: function () {
			exitEditToothMode();
			if (vueApp.isIntraoralView) {
				loadOrthoStage(-1);
			}
		},
		cancelPlanMode: function () {
			cancelOrthoChanges();
			if (vueApp.isIntraoralView) {
				loadOrthoStage(-1);
			}
		},
		saveExitPlanMode: function () {
			saveOrthoChanges();
			if (vueApp.isIntraoralView) {
				loadOrthoStage(-1);
			}
		},
		saveAsStagePlanMode: function () {
			showOrthoStageDialog(true);
		},
		nextStagePlanMode: function () {
			console.log("nextStagePlanMode");
			saveOrthoChanges(true);
			showOrthoStageDialog(false);
		},
		anatomyChangeReportClick: function () {
			anatomyChangeReport();
		},
	}
};
</script>

<style scoped>
/* @import "opacity.css";
*/

#orthoPlanButtons {
	left: calc(50% - 128px);
	bottom: 65px;
	z-index: 9;
	display: none;
	width: 330px;
	height: 35px;
}

#orthoSaveButtons {
	position: absolute;
	max-width: 330px;
	height: 35px;
	left: -56px;
	text-align: center;
	white-space: nowrap;
}

.ortho-button {
	display: inline-block;
	margin-right: 10px;
	min-width: 90px;
	width: auto;
	height: 35px;
	/* left: calc(50% - 57px); */
	/* bottom: 65px; */
	border: 0;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	/*#F7FAFF;*/
	text-align: center;
	color: #ffffff;
	/* position: absolute; */
}

#orthoToothDoneButton {
	display: none;
	position: absolute;
	width: 90px;
	left: 110px;
	/* left: calc(50% - 5x); */
}

.orto-report-button {
	position: absolute;
	width: 220px;
    left: 28px;
    bottom: 50px;
}

@media screen and (max-width: 650px) {
	#orthoSaveButtons {
		left: -25px;
	}
}
</style>